/**
 * Upper bounds shared by the backoffice form and the server validators.
 *
 * The count matches `QUICK_LINK_MAX_GROUPS`: both are editor-managed lists
 * rendered in full, and a cap that differs per list would only be a number to
 * look up rather than a rule to remember.
 */
export const CHANNEL_MAX_COUNT = 20;
export const CHANNEL_MAX_LABEL_LENGTH = 255;
